import React, { useState } from "react";
import { initiateHandshake } from '../../utils/HandshakeManager';
import { usePasswordAndUserId } from "../../context/AuthContext";
import bs58 from "bs58";

export default function InviteRequestMessage({
  conversationId,
  participant,
  localKeys,
  fullScreen = false,
  canDismiss = false,
}) {
  const [status, setStatus] = useState("init");
  const [customMessage, setCustomMessage] = useState("");
  const [dismissed, setDismissed] = useState(false);
  const { password, userId, salt } = usePasswordAndUserId();

  if (!participant?.identityViewPublicKey || dismissed) return null;

  const participantName = participant.name || bs58.encode(participant.identityViewPublicKey).slice(0, 10);

  const sendInvite = async () => {
    try {
      setStatus("sending");
      await initiateHandshake({
        conversationId,
        contactIdentityViewPublicKey: participant.identityViewPublicKey,
        password,
        userId,
        salt,
        message: customMessage.trim().slice(0, 100),
      });
      setStatus("sent");
    } catch (err) {
      console.error("Failed to send handshake invite:", err);
      setStatus("error");
    }
  };

  const handleDismiss = () => {
    setDismissed(true);
  };

  return (
    <div
      style={{
        background: "#222",
        padding: fullScreen ? "2rem 1.5rem" : "1rem",
        borderRadius: "8px",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        maxWidth: fullScreen ? "600px" : "80%",
        alignSelf: "center",
        margin: fullScreen ? "auto" : "1rem 0",
        boxSizing: "border-box",
        justifyContent: fullScreen ? "center" : "initial",
        minHeight: fullScreen ? "60vh" : "initial",
        alignItems: fullScreen ? "center" : "flex-start",
        textAlign: fullScreen ? "center" : "left",
        position: "relative",
      }}
    >
      {canDismiss && (
        <button
          onClick={() => handleDismiss()}
          style={{
            position: "absolute",
            top: "0.5rem",
            right: "0.5rem",
            background: "none",
            border: "none",
            color: "#aaa",
            fontSize: "1rem",
            cursor: "pointer",
          }}
        >
          ✕
        </button>
      )}

      {fullScreen && (
        <img
          src="/images/logo.png"
          alt="Logo"
          style={{
            width: "200px",
            margin: "0 auto 1.5rem",
            opacity: 0.9,
          }}
        />
      )}

      <p
        style={{
          marginBottom: "1rem",
          textAlign: "center",
          fontSize: "1.1rem",
          lineHeight: "1.5",
        }}
      >
        Send <strong>{participantName}</strong> a chat invite to get your secure conversation going.
      </p>

      <textarea
        placeholder="Add a short message (optional)"
        value={customMessage}
        onChange={(e) => setCustomMessage(e.target.value.slice(0, 100))}
        maxLength={100}
        rows={3}
        style={{
          width: "100%",
          boxSizing: "border-box",
          background: "#333",
          border: "1px solid #444",
          borderRadius: "6px",
          color: "#fff",
          padding: "0.5rem",
          marginBottom: "1rem",
          resize: "none",
        }}
      />

      <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.5rem" }}>
        <button
          onClick={sendInvite}
          disabled={status === "sending" || status === "sent"}
          style={{
            background: status === "sent" ? "#2ecc71" : "#4e8cff",
            color: "#fff",
            border: "none",
            padding: "0.75rem 1.25rem",
            borderRadius: "6px",
            fontSize: "1rem",
            cursor: status === "sending" || status === "sent" ? "default" : "pointer",
            opacity: status === "sending" ? 0.6 : 1,
          }}
        >
          {status === "sending"
            ? "Sending…"
            : status === "sent"
            ? "Invite Sent"
            : "Send Chat Invite"}
        </button>
      </div>
    </div>
  );
}